import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import * as actions from "./actions";
import * as actionTypes from "./actionTypes";
import { isArray } from "lodash";

import axios from "axios";

function* getAttachmentsList({ payload }) {
  const { chatId } = payload;

  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/ticket/${chatId}/files`
    );

    yield put(actions.getAttachmentsListSuccess(chatId, response.data));
  } catch (error) {
    let message =
      "Sorry! something went wrong, please contact our support team";
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(actions.getAttachmentsListFailure(chatId, message));
  }
}

function* updateAttachmentStatus({ payload }) {
  const { chatId, interactionId, fileStatus, reason } = payload;

  try {
    const response = yield call(
      axios.put,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/ticket/${chatId}/files/${interactionId}`,
      {
        fileStatus,
        reason,
      }
    );

    yield put(
      actions.updateAttachmentStatusSuccess(chatId, {
        fileStatus,
      })
    );

    yield put(actions.getAttachmentsList(chatId));
  } catch (error) {
    let message =
      "Sorry! something went wrong, please contact our support team";
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(actions.updateAttachmentStatusFailure(chatId, message));
  }
}

function* uploadAttachments({ payload }) {
  const { closeModal, t, ...data} = payload;
  try {   
    yield call(
      axios.post,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/ticket/send/interaction`,
      data
    );   
    yield put(actions.uploadAttachmentsSuccess({...data, message:  t(`Files uploaded successfully`) }));
    yield put(actions.getAttachmentsList(data?.conversationId));
  } catch (error) {
    let message =
      "Sorry! something went wrong, please contact our support team";
    if (error.response && error.response.status) {
      console.log(error.response);
      switch (error.response.status) {
        case 400:
          if (isArray(error?.response?.data?.message)) {
            error?.response?.data?.message.forEach((el) => {
              if (el.value === 'format file not allowed') {
          message = el.value;
              }
            });
          } 
          break;
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! It wasn't possible to upload the attachments.";
          }
          break;
        case 500:
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }    
    yield put(actions.uploadAttachmentsFailure({message: t(message)}));
  }

  try {
    if(closeModal){
      closeModal();
    }
  } catch (error) {
    
  }
}

function* requestAttachment({payload}) {
  const { closeModal, t, ...data} = payload;
  try { 
    yield call(
      axios.post,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/ticket/request/interaction`,
      data
    );   
    yield put(actions.requestAttachmentSuccess({...data, message: t(`Document successfully requested`)}));
    yield put(actions.getAttachmentsList(data?.conversationId));
  } catch (error) {    
    let message =
      "Sorry! something went wrong, please contact our support team";
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! It wasn't possible to upload the attachments.";
          }
          break;
        case 500:
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    
    yield put(actions.requestAttachmentFailure({message: t(`Error requesting document`)}));
  }

  try {
    if(closeModal){
      closeModal();
    }
  } catch (error) {
    
  }
}

function* watchUpdateAttachmentStatus() {
  yield takeEvery(actionTypes.UPDATE_ATTACHMENT_STATUS, updateAttachmentStatus);
}

function* watchGetAttachmentsList() {
  yield takeEvery(actionTypes.GET_ATTACHMENTS_LIST, getAttachmentsList);
}

function* watchUploadAttachments() {
  yield takeEvery(actionTypes.UPLOAD_ATTACHMENTS, uploadAttachments);
}

function* watchRequestAttachment() {
  yield takeEvery(actionTypes.REQUEST_ATTACHMENT, requestAttachment);
}

export default function* rootSaga() {
  yield all([
    fork(watchGetAttachmentsList),
    fork(watchUpdateAttachmentStatus),
    fork(watchUploadAttachments),
    fork(watchRequestAttachment),
  ]);
}
